import { render, staticRenderFns } from "./PalletScanProducts.vue?vue&type=template&id=66b4b34a"
import script from "./PalletScanProducts.vue?vue&type=script&lang=js"
export * from "./PalletScanProducts.vue?vue&type=script&lang=js"
import style0 from "./PalletScanProducts.vue?vue&type=style&index=0&id=66b4b34a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports